import React from "react";
import PropTypes from "prop-types";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import {
  setPlayerSearchedName,
  setPositionFilter,
  setTeamFilter,
  setPlayerStatus,
  dataRequest,
  dataSuccess,
  setGameInformation,
  setLeague,
  setMatchDatetime,
  setCompleteGameInformation,
  setInMemoryTimeframes,
} from "../../redux/GameInformation/GameInformationAction";
import { API_CONSTANTS } from "../../utils/constantInformation";
import { fetchDataForPlatformAndLeague } from "../../utils/apiUtils";
// {
//   "teamA": "Team1",
//   "teamB": "Team2",
//   "topic": "dev",
//   "platform": "Dream11",
//   "sport": "Cricket",
//   "league": "Premier League",
//   "season": "2023",
//   "slateID": "SL123"
// }
const ReactNotificationComponent = (props) => {
  // extract platform, sport, league, season, slateID, title, body from props
  const { platform, sport, league, season, slateID, title, body } = props;
  let hideNotif = title === "";
  console.log(
    "Notification Data: ",
    platform,
    sport,
    league,
    season,
    slateID,
    title,
    body
  );
  if (!hideNotif) {
    toast.info(<Display />, { theme: "dark" });
  }
  const handleNotificationClick = () => {
    toast.dismiss();
    fetchDataForPlatformAndLeague(platform, sport, league)
      .then((data) => {
        console.log("Notification Slate Fetch Success:", data);
        props.updateAPIResult(data);
        var time_frames = [];
        var temp_check = [];
        // This makes date based match timeframes
        data.forEach((el) => {
          console.log("Result EL: ", el);
          if (temp_check.indexOf(el.slate_timeframe) == -1) {
            time_frames.push({
              slate_id: el.SlateID,
              slate_timeframe: el.slate_timeframe,
            });
            temp_check.push(el.slate_timeframe);
          } else {
            console.error("### TimeFrames EMPTY..! ####");
          }
        });
        props.changeInMemoryTimeframe(time_frames);
        const concernedSlate = data.filter((el) => {
          return el.SlateGameID === slateID;
        })[0];
        console.log("Concerned Slate: ", concernedSlate);
        let game_info = {
          platform: platform.toLowerCase(),
          sports: league,
          selected_timeframe: concernedSlate.Date,
          slate_id: concernedSlate.SlateGameID,
        };

        props.updateLeague(league.toUpperCase());
        props.game_information(game_info);
        props.updateSearchString("");
        props.update_filtered_team("Both");
        props.updatePosition("ALL");
        //   // here reset the player status redux state too
        props.update_player_status(API_CONSTANTS.NULL_CONSTANT);

        props.set_datetime_for_countdown(concernedSlate.GameDateTime);

        props.dataSuccess();

        //   // Setting countdown timer
      })
      .catch((error) => {
        console.log("Notification Slate Fetch Error: ", error);
      });
  };
  function Display() {
    return (
      <div onClick={handleNotificationClick}>
        <h4>{title}</h4>
        <p>{body}</p>
      </div>
    );
  }

  return (
    <ToastContainer
      position="bottom-right"
      autoClose={false}
      hideProgressBar={false}
      newestOnTop={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
};
//
// function saveAllSelections(slate_id, date) {

// }

ReactNotificationComponent.defaultProps = {
  title: "This is title",
  body: "Some body",
};

ReactNotificationComponent.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
};
const mapDispatchToProps = (dispatch) => {
  return {
    game_information: (value) => dispatch(setGameInformation(value)),
    updateLeague: (value) => dispatch(setLeague(value)),
    updateSearchString: (value) => dispatch(setPlayerSearchedName(value)),
    updatePosition: (value) => dispatch(setPositionFilter(value)),
    update_filtered_team: (value) => dispatch(setTeamFilter(value)),
    update_player_status: (value) => dispatch(setPlayerStatus(value)),
    set_datetime_for_countdown: (value) => dispatch(setMatchDatetime(value)),
    dataRequest: () => dispatch(dataRequest()),
    dataSuccess: () => dispatch(dataSuccess()),
    updateAPIResult: (value) => dispatch(setCompleteGameInformation(value)),
    changeInMemoryTimeframe: (value) => dispatch(setInMemoryTimeframes(value)),
  };
};

export default connect(null, mapDispatchToProps)(ReactNotificationComponent);
